export const GOOGLE_VOICES = [
	'Zephyr',
	'Puck',
	'Charon',
	'Kore',
	'Pulcherrima',
	'Achird',
	'Zubenelgenubi',
	'Vindemiatrix',
	'Sadachbia',
	'Sadaltager',
	'Sulafat',
] as const;

export type GoogleVoice = (typeof GOOGLE_VOICES)[number];

export function googleVoicePreviewUrl(voice: GoogleVoice): string {
	return `assets/audio/${voice}.wav`;
}

export type TtsProvider = 'google';

export interface GenerateTtsRequest {
	text: string;
	speaker: GoogleVoice;
	provider?: TtsProvider;
	override?: boolean;
}

export interface TtsResponse {
	publicUrl: string;
	audioId: string;
	provider: TtsProvider;
}
